import { FilterValue, SorterResult } from 'antd/lib/table/interface'
import { isArray } from 'lodash'
import { ISort, IStaticFilter } from '../../models/base/base-query'
import { Orders, Operations } from '../../models/base/enum'

///
// Handle Sorts and Filters in Antd Table
///
export const tableOnChange = (
  tableFilters: Record<string, FilterValue | null>,
  tabelSorters: SorterResult<any> | SorterResult<any>[],
  tableFiltersProps: Object,
  setSorts: (sorters: ISort[]) => void,
  setStaticFilters: (filters: IStaticFilter[]) => void
) => {
  // Sorts
  if (!isArray(tabelSorters)) tabelSorters = [tabelSorters]
  let sorters: ISort[] = []
  tabelSorters?.map((sort, _) => {
    let sortOrder = sort?.order === 'ascend' ? Orders.ascend : Orders.descend

    sorters.push({
      name: `${sort.field}`,
      direction: sortOrder,
    })
  })
  setSorts(sorters)

 // Filters
  let filters: IStaticFilter[] = []
  Object.entries(tableFilters).forEach(([key, value]) => {
    if (value !== null) {
      let operation = Operations.EQ
      let convertedValue: any
      
      if (Array.isArray(value)) {
        // Handle multiple selections
        convertedValue = value.map(v => 
          typeof v === 'string' && !isNaN(Number(v)) ? Number(v) : v
        )
      } else {
        // Handle single selection
        convertedValue = typeof value === 'string' && !isNaN(Number(value)) ? Number(value) : value
      }

      filters.push({
        name: key,
        operation: operation,
        value: convertedValue,
      })
    }
  })
  setStaticFilters(filters)
}
